import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type LoaderSource = "api" | "route";

interface GlobalLoaderState {
  apiPending: number;
  routePending: number;
}

const initialState: GlobalLoaderState = {
  apiPending: 0,
  routePending: 0,
};

function clampNonNegative(n: number) {
  return n < 0 ? 0 : n;
}

export const globalLoaderSlice = createSlice({
  name: "globalLoader",
  initialState,
  reducers: {
    start: (state, action: PayloadAction<{ source: LoaderSource }>) => {
      if (action.payload.source === "api") state.apiPending += 1;
      if (action.payload.source === "route") state.routePending += 1;
    },
    stop: (state, action: PayloadAction<{ source: LoaderSource }>) => {
      if (action.payload.source === "api") {
        state.apiPending = clampNonNegative(state.apiPending - 1);
      }
      if (action.payload.source === "route") {
        state.routePending = clampNonNegative(state.routePending - 1);
      }
    },
    reset: (state) => {
      state.apiPending = 0;
      state.routePending = 0;
    },
  },
});

export const { start: startGlobalLoader, stop: stopGlobalLoader, reset } =
  globalLoaderSlice.actions;

export const selectIsGlobalLoaderVisible = (state: any) =>
  (state?.globalLoader?.apiPending ?? 0) > 0 ||
  (state?.globalLoader?.routePending ?? 0) > 0;

export default globalLoaderSlice.reducer;
